// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=\"rtl\"] div span::after {\n  transform: rotateY(180deg);\n}\n[dir=\"rtl\"] div .RightArrowIcon {\n  transform: rotateY(180deg);\n}\n[dir=\"rtl\"] a .arrowBackIcon {\n  transform: rotateY(180deg);\n}\n[dir=\"rtl\"] [align=\"right\"] {\n  text-align: left;\n}\n[dir=\"rtl\"] .selected-text:after {\n  left: 17px;\n  right: auto;\n}\n[dir=\"rtl\"] .MuiBreadcrumbs-ol > .MuiBreadcrumbs-separator svg{\n  transform: rotateY(180deg);\n}\n", ""]);
// Exports
module.exports = exports;
